import React from "react";
import gsocIdeas from "../../assets/constants/GSoC";
import {
    PageContainer,
    PageHeading,
    PageSubheading,
    SectionHeading,
    HoursBadge,
    ProjectCard,
    ProjectHeader,
    ProjectTitle,
    ProjectId,
    ProjectBrief,
    MetaGrid,
    MetaItem,
    MetaLabel,
    MetaValue,
    ReadingSection,
    ReadingLabel,
    ReadingList,
    ReadingItem,
    ReadingLink,
    DifficultyBadge,
} from "./GSoCUI";

const mentorEmails = {
    "Shanthanu S. Rai": "shanthanu.s.rai9@gmail.com",
    "Abhinaba Rakshit": "abhinaba.fbr@gmail.com",
    "Ishaan Singh": "jayash1819@gmail.com",
    "Ikjot Singh": "jayash1819@gmail.com",
    "Dayma Khan": "daymakhan23@gmail.com",
    "Kaustubh Sharma": "kaustubhsharma105@gmail.com",
    "Aniket Singh": "aniketsingh84646@gmail.com",
    "Nitin Dabi": "nitindabi954@gmail.com",
    "Dhanasekhar M": "dhanasekhar@example.com",
};

const MentorLink = ({ name }) => {
    const email = mentorEmails[name.trim()];
    if (email) {
        return <a href={`mailto:${email}`} style={{ color: "inherit" }}>{name}</a>;
    }
    return name;
};

const renderMentors = (mentorString) => {
    const parts = mentorString.split(/( and |, )/);
    return parts.map((part, idx) =>
        part === " and " || part === ", " ? part : <MentorLink key={idx} name={part} />
    );
};

const ProjectCardComponent = ({ project }) => {
    return (
        <ProjectCard>
            <ProjectHeader>
                <ProjectId>#{project.id}</ProjectId>
                <ProjectTitle>{project.title}</ProjectTitle>
                <HoursBadge>~{project.hours} hours</HoursBadge>
            </ProjectHeader>

            <ProjectBrief>{project.brief}</ProjectBrief>

            <MetaGrid>
                <MetaItem>
                    <MetaLabel>Required Experience</MetaLabel>
                    <MetaValue>{project.requiredExperience}</MetaValue>
                </MetaItem>
                <MetaItem>
                    <MetaLabel>Bonus Experience</MetaLabel>
                    <MetaValue>{project.bonusExperience}</MetaValue>
                </MetaItem>
                <MetaItem>
                    <MetaLabel>Difficulty</MetaLabel>
                    <MetaValue>
                        <DifficultyBadge level={project.difficulty}>
                            {project.difficulty}
                        </DifficultyBadge>
                    </MetaValue>
                </MetaItem>
                {project.mentor && (
                    <MetaItem>
                        <MetaLabel>Mentor</MetaLabel>
                        <MetaValue>{renderMentors(project.mentor)}</MetaValue>
                    </MetaItem>
                )}
            </MetaGrid>

            <ReadingSection>
                <ReadingLabel>Recommended Reading</ReadingLabel>
                <ReadingList>
                    {project.reading.map((item, index) => (
                        <ReadingItem key={index}>
                            <ReadingLink
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {item.title} ↗
                            </ReadingLink>
                        </ReadingItem>
                    ))}
                </ReadingList>
            </ReadingSection>
        </ProjectCard>
    );
};

const GSoC = () => {
    const { largeProjects, smallProjects, mediumProjects } = gsocIdeas;

    return (
        <PageContainer>
            <PageHeading>GSoC 2026 Project Ideas for NeST</PageHeading>
            <PageSubheading>
                Explore our list of Google Summer of Code project ideas for
                Network Stack Tester (NeST)
            </PageSubheading>

            <SectionHeading>
                Large Projects
                <HoursBadge>~350 hours</HoursBadge>
            </SectionHeading>
            {largeProjects.map((project) => (
                <ProjectCardComponent key={project.id} project={project} />
            ))}

            <SectionHeading>
                Medium Projects
                <HoursBadge>~175 hours</HoursBadge>
            </SectionHeading>
            {mediumProjects.map((project) => (
                <ProjectCardComponent key={project.id} project={project} />
            ))}

            <SectionHeading>
                Small Projects
                <HoursBadge>~90 hours</HoursBadge>
            </SectionHeading>
            {smallProjects.map((project) => (
                <ProjectCardComponent key={project.id} project={project} />
            ))}
        </PageContainer>
    );
};

export default GSoC;
